import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { AudienceSection } from './components/AudienceSection';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { InactionCostSection } from './components/InactionCostSection';
import { AuthorNote } from './components/AuthorNote';
import { FAQSection } from './components/FAQSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full" data-id="element-0" data-mp="3ij61y35c994p">
      <HeroSection data-id="element-1" data-mp="3mljat0fdtn5p" />
      <OpeningHook data-id="element-2" data-mp="3ml1397n9rmih" />
      <ProblemSection data-id="element-3" data-mp="3mkho1yp07c85" />
      <FailedSolutions data-id="element-4" data-mp="3mjq1tehaqquj" />
      <MechanismSection data-id="element-5" data-mp="3mj6jhwnqi0fz" />
      <WhatYouGet data-id="element-6" data-mp="3rbrayrj641gc" />
      <AudienceSection data-id="element-7" data-mp="3rdaselgk8ijp" />
      <HowItWorks data-id="element-8" data-mp="3rd1azm9kzjpm" />
      <ProofSection data-id="element-9" data-mp="3relumgucxi8p" />
      <TestimonialsSection data-id="element-10" data-mp="5orh0l86u6j" />
      <InactionCostSection data-id="element-11" data-mp="4wx1t3d72hu" />
      <AuthorNote data-id="element-12" data-mp="56m9egl55mh" />
      <FAQSection data-id="element-13" data-mp="7stfczkdj46" />
      <PricingSection data-id="element-14" data-mp="2zld1r8m3ndb0" />
      <Footer data-id="element-15" data-mp="2zm4ywnvchj3e" />
    </div>;
}